import { api_post } from '@lf/api-client/lfApi';

export async function getProgressSummary(days = 30, setError) {
    try {
        const response = await api_post('/progress/summary', { days }, setError);
        if (response && response.status === 200) {
            return response.data;
        }
        return null;
    } catch (error) {
        console.error('Error fetching progress summary:', error);
        return null;
    }
}
